// PDF IO policy only. The backend is authoritative and revalidates at launch.
export function hasGtIoBuyingModel(config) {
  return config?._io_buying_model?.version === 1 && config._io_buying_model.source === 'pdf';
}

export function applyGtIoBuyingModel(config) {
  if (!hasGtIoBuyingModel(config)) return;
  const model = config._io_buying_model.source_model === 'CPC'
    || String(config.campaign?.buying_model_raw || '').toUpperCase() === 'CPC' ? 'CPC' : 'CPM';
  config.campaign.buying_model_raw = model;
  for (const ag of config.adgroups || []) {
    ag.bid_type = model;
    ag.optimization_strategy = model === 'CPC' ? 'click' : 'delivery';
    ag.cts_buying_model = model.toLowerCase();
  }
}

export function recordGtIoTermEdit(config, ag, field, value) {
  if (!hasGtIoBuyingModel(config) || !Number.isFinite(value) || value <= 0) return;
  if (field === 'bid_price' || (field === 'clicks' && Number.isSafeInteger(value))) {
    ag._io_cpc_terms = { ...ag._io_cpc_terms, [field]: value };
  }
}
